export default function StockFilter() {

    const urlParams = new URLSearchParams(window.location.search);
    let params = [];

    const stockStatus = urlParams.get('stock_status');

    if (stockStatus !== null) {
        params = stockStatus.split(',');

        for (const param of params) {
            $(`#${param}`).prop('checked', true);
        }
    }

    $('.stock-status-filter').on('click', function (e) {
        console.log(params);

        if ($(this).prop('checked')) {
            params.push($(this).val());
        } else {
            const index = params.indexOf($(this).val());
            if (index !== -1) params.splice(index, 1);
        }

        if ( params.length > 0) {
            window.location.search = 'stock_status=' + params.join(',');
        } else{
            window.location.search = '';
        }


    });

};